// ANCHOR React Icons Kit
import Icon from 'react-icons-kit';
import { externalLink } from 'react-icons-kit/fa/externalLink';

// ANCHOR Base
import { Block } from 'baseui/block';
import { StyledLink } from 'baseui/link';
import {
  Button, ButtonOverrides, KIND, SIZE,
} from 'baseui/button';

// ANCHOR Utils
import { formatPHPCurrency } from '@lyon/utils/extras/formatPHPCurrency';
import { keyedInterpolate } from '@lyon/utils/extras/stringInterpolate';
import { approximatelyEqual } from '@lyon/utils/extras/approximatelyEqual';

// ANCHOR Constants
import { FREE_LABEL, LABEL } from './constants';

interface IPaymentButtonProps {
  price?: number;
  disabled?: boolean;
  overrides?: ButtonOverrides;
}

interface IProps extends IPaymentButtonProps {
  onClick: () => Promise<void>;
  paymentLink?: string;
}

export function ContentBuyButton({
  price,
  disabled,
  onClick,
  overrides,
  paymentLink,
}: IProps) {
  if (paymentLink) {
    if (disabled) {
      <Button
        kind={KIND.primary}
        size={SIZE.default}
        isLoading={typeof price === 'undefined'}
        disabled={disabled}
        overrides={overrides}
      >
        {
          approximatelyEqual(price ?? 0, 0)
            ? FREE_LABEL
            : keyedInterpolate(LABEL, {
              price: formatPHPCurrency(price),
            })
        }
        <Block marginLeft="8px">
          <Icon icon={externalLink} />
        </Block>
      </Button>;
    }

    return (
      <StyledLink
        href={paymentLink}
        target="_blank"
        rel="noopener noreferrer"
        $style={{ textDecoration: 'none' }}
      >
        <Button
          kind={KIND.primary}
          size={SIZE.default}
          isLoading={typeof price === 'undefined'}
          disabled={disabled}
          overrides={overrides}
        >
          {
            approximatelyEqual(price ?? 0, 0)
              ? FREE_LABEL
              : keyedInterpolate(LABEL, {
                price: formatPHPCurrency(price),
              })
          }
          <Block marginLeft="8px">
            <Icon icon={externalLink} />
          </Block>
        </Button>
      </StyledLink>
    );
  }

  return (
    <Button
      kind={KIND.primary}
      size={SIZE.default}
      isLoading={typeof price === 'undefined'}
      onClick={onClick}
      disabled={disabled}
      overrides={overrides}
    >
      {
        approximatelyEqual(price ?? 0, 0)
          ? FREE_LABEL
          : keyedInterpolate(LABEL, {
            price: formatPHPCurrency(price),
          })
      }
    </Button>
  );
}
